import React, { useState } from "react";
import "./header.css";
const SmallScreenHeader = ({ setDisplayNav, displayNav }) => {
    const [display, setDisplay] = useState(displayNav);
    return (
        <div
            id="small_screen"
            onClick={() => {
                setDisplay(false);
                setTimeout(() => {
                    setDisplayNav(false);
                }, 200);
            }}
        >
            <nav className={display ? "active" : "close"}>
                <button
                    onClick={() => {
                        setDisplay(false);
                        setTimeout(() => {
                            setDisplayNav(false);
                        }, 200);
                    }}
                >
                    <i class="bi bi-x-lg"></i>
                </button>
                <ul>
                    <li>
                        <a href="#">בית</a>
                    </li>
                    <li>
                        <a href="#about">אודות</a>
                    </li>
                    <li>
                        <a href="#services">מה אנחנו עושים</a>
                    </li>
                    <li>
                        <a href="#works">העבודות שלנו</a>
                    </li>
                    <li>
                        <a href="#faq">שאלות & תשובות</a>
                    </li>
                    <li>
                        <a href="#contact">צרו קשר</a>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default SmallScreenHeader;
